module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-semibold-webfont-2edc73e0f9a45b9b1347060013eb39df.woff";